var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00039 12.6665C7.43905 12.6665 6.87705 12.5479 6.33105 12.3365",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9213 8.31201C12.66 10.6447 10.33 12.6667 8 12.6667",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7197 5.94727C13.1804 6.4866 13.5897 7.0746 13.9217 7.6886C14.0264 7.8826 14.0264 8.11793 13.9217 8.31193",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 12.6666L12.6663 3.33325",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51539 9.48466C5.69539 8.66466 5.69539 7.33466 6.51539 6.51466C7.33539 5.69466 8.66539 5.69466 9.48539 6.51466",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3625 4.63725C10.3312 3.83925 9.16517 3.33325 7.99983 3.33325C5.66983 3.33325 3.33983 5.35525 2.0785 7.68859C1.97383 7.88259 1.97383 8.11792 2.0785 8.31192C2.70917 9.47792 3.6065 10.5659 4.63717 11.3633",
    stroke: "#21201D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffIcon);
export default __webpack_public_path__ + "static/media/VisibilityOffIcon.6e45efca3186aef02c870598bb660c05.svg";
export { ForwardRef as ReactComponent };